module.exports = __webpack_public_path__ + "static/group2_3-8441849d644a0657d3df4843c605e123.webp";